import { Toaster as Sonner  } from 'sonner'
import type {ToasterProps} from 'sonner';
import { useTheme } from '@/store/UserPreferencesStore'

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // Stable hook for E2E tests. Sonner forwards unknown props to the root
      // ol[data-sonner-toaster], so this lands on the live region itself —
      // tests can scope toast queries to `[data-testid="toast-region"]`.
      data-testid="toast-region"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
